/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_TrackingInputs */

const en_orders_tracking = /** @type {(inputs: Orders_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking`)
};

const es_orders_tracking = /** @type {(inputs: Orders_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking`)
};

/**
* | output |
* | --- |
* | "Tracking" |
*
* @param {Orders_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_tracking = /** @type {((inputs?: Orders_TrackingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_TrackingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_tracking(inputs)
	return es_orders_tracking(inputs)
});